import { Component, Input } from '@angular/core';

@Component({
  selector: 'organization-logo',
  templateUrl: 'organization-logo.html'
})
export class OrganizationLogoComponent {

  @Input()
  image:string = null;

  logo:string = "assets/images/logo-dots.png";

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/components/organization-logo/organization-logo.ts